import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import {
  ResponsiveContainer,
  BarChart,
  Bar,
  Cell,
  XAxis,
  Tooltip
} from 'recharts';

import {
  StyledBoxPrincipal,
  StyledTitleContainer,
  StyledText,
  StyledFullScreenIcon
} from './style';
import { SizeFull } from '../../../../assets/images/index';

import { getLiteralMonth, getObjDate } from '../../../utils/dates';
import {
  getReducedChannelsShare,
  getChannelsShare,
  orderByShare,
  sharingBarsColorsPalindrome
} from '../../../utils/audiences';
import { dataDailyShareModel } from '../../../utils/models';

import TooltipContent from './tooltip';
import ChannelLogos from './channelLogos';

const ChannelShare = ({ reduced, data, expandable }) => {
  const updatedData = reduced
    ? getReducedChannelsShare(data)
    : getChannelsShare(data);
  const sortedData = orderByShare(updatedData);
  const date = getObjDate(data.day);
  const blackLogosData = updatedData.map(logo => logo.blackLogo);
  const tooltipActive = false;
  const { day, month, year } = date;

  return (
    <StyledBoxPrincipal>
      <StyledTitleContainer>
        <StyledText>{`Share medio del día ${day} de ${getLiteralMonth(
          month
        )} de ${year}`}</StyledText>
        {expandable && (
          <Link to="/audiencias/ranking_cadenas">
            <StyledFullScreenIcon color="dark" svg={SizeFull} size="sm" />
          </Link>
        )}
      </StyledTitleContainer>

      <ResponsiveContainer>
        <BarChart
          data={sortedData}
          barCategoryGap={0}
          margin={{ top: 30, right: 0, left: 0, bottom: -15 }}
        >
          <XAxis
            type="category"
            tickLine={false}
            tick={false}
            dataKey="share"
            axisLine={{ stroke: '#4c4c4c', strokeWidth: 2 }}
          />
          <Tooltip
            content={<TooltipContent />}
            active={tooltipActive}
            cursor={{
              fill: '#e7e7e7'
            }}
          />
          <Bar
            dataKey="share"
            fill="red"
            label={{ fill: '#000000', fontSize: 14, position: 'top' }}
            isAnimationActive={false}
          >
            {sortedData.map((audience, index) => (
              <Cell
                key={audience.channel}
                fill={
                  sharingBarsColorsPalindrome[
                    index % sharingBarsColorsPalindrome.length
                  ]
                }
              />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
      <ChannelLogos logos={blackLogosData} />
    </StyledBoxPrincipal>
  );
};

ChannelShare.propTypes = {
  data: dataDailyShareModel,
  expandable: PropTypes.bool,
  reduced: PropTypes.bool
};

ChannelShare.defaultProps = {
  expandable: false,
  reduced: true
};

export default ChannelShare;
